// Module
var code = `<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: cancel" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <h4 class="modal-title" data-bind="text: title"></h4>
        </div>
        <div class="modal-body force-text-wrap">
            <p data-bind="html: subTitleHtml"></p>
            <ul data-bind="foreach: itemKeys" style="max-height: 200px; overflow-y: auto;"> 
                <li class="padding padding-xs">
                    <strong data-bind="text: \$data"></strong>
                </li>
            </ul>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bind="click: cancel">Cancel</button>
            <button type="button" class="btn btn-primary" data-bind="click: deleteItems">Delete</button>
        </div>
    </div>
</div>
`;
// Exports
export default code;